<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button type="primary" size="small" @click="openAdd" :title="$t('add')" icon="el-icon-edit"></el-button>
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
            </div>
            <div class="fillw fillh">
                <div class="tree-box fillh" style="overflow-y: auto">
                    <div v-if="listData.length > 0">
                        <div v-for="item in listData" :key="item.role_id">
                            <div class="flex-box pd-5">
                                <Icon class="f-back mg-right5" type="ios-ribbon" />{{item.role_cname}}
                                <div class="flex-box-bd"></div>
                                <el-button class="round-5 mg-right5" type="primary" size="mini" @click="openAddUser(item)">{{$t("insert_user")}}</el-button>
                                <el-button class="round-5 mg-right5" type="success" size="mini" @click="openConfig(item)">{{$t("set_func")}}</el-button>
                                <el-button class="round-5 mg-right5" type="warning" size="mini" @click="openSave(item.role_id)">{{$t("info")}}</el-button>
                                <el-button class="round-5" type="danger" size="mini" @click="delRole(item.role_id)">{{$t("del")}}</el-button>
                            </div>
                            <div class="sub-tree c1">
                                <div class="sub-tree c2" v-for="item2 in item.users" :key="item2.u_id">
                                <span>
                                    <Icon class="left-icon f-back" type="md-contact" />
                                    {{item2.user_code}}({{item2.user_cname}})
                                    <a class="f-red" @click="removeUser(item.role_id,item2.u_id)"><Icon size="24" type="md-backspace" /></a>
                                </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <myNodata></myNodata>
                    </div>
                </div>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    import myNodata from '../../../components/myNodata'
    export default {
        name:"org-role",
        components:{
            myNodata
        },
        data:function(){
        const listHeader = {
            role_cname:'角色'
        }
        const listHeader2 = {
            user_cname:'员工'
        }
            return{
                show_subview:false,
                relist:false,
                search:{
                    search_url:'role/list'
                },
                listTable: {},//表结构
                listHeader,
                listHeader2,
                listData: [],
                totalData: {
                    total: 0,//总行数
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.$base.listPageInit(this,()=>{
                this.list();
            });
        },
        methods:{
            list: function () {
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            exportExcel:function() {
                this.$base.exportExcelL3(this,'users')
            },
            openAdd:function () {
                this.$base.linkTo("/org/role/save",{op:'add'});
            },
            openSave:function (id) {
                this.$base.linkTo("/org/role/save",{op:'upd', id});
            },
            openAddUser:function (item) {
                this.$base.linkTo("/org/role/user",{id:item.role_id,role_cname:item.role_cname});
            },
            openConfig:function (item) {
                this.$base.linkTo("/org/role/func",{id:item.role_id,role_cname:item.role_cname});
            },
            //删除角色
            delRole: function (role_id) {
                let data = {
                    role_id: role_id
                };
                let content = this.$t('chk_del_role');
                this.$base.confirm(content, () => {
                    this.$base.showLoading();
                    this.$request.sendPost("role/del",data,(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.list();
                        }
                        else{
                            this.$base.msgErr(error.errmsg);
                        }
                    });
                },()=>{})
            },
            removeUser: function (role_id,u_id) {
                let data = {
                    u_id: u_id,
                    role_id: role_id
                };
                let content = this.$t('chk_del_user');
                this.$base.confirm(content, () => {
                    this.$base.showLoading();
                    this.$request.sendPost("role/del-user",data,(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.list();
                        }
                        else{
                            this.$base.msgErr(error.errmsg)
                        }
                    });
                },()=>{})
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(true);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>
    .tree-box{
        max-width: 600px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/org/role/role.vue